import { render, staticRenderFns } from "./root-ondemand.vue?vue&type=template&id=2e540cc1"
import script from "./root-ondemand.vue?vue&type=script&lang=js"
export * from "./root-ondemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports